class UserService {
    constructor() {
        this.user = undefined;
    }
}

var userService = new UserService();
export default userService;